import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BundleResponse } from '../types/bundle.model';
import { CONFIG } from '@domgen/dgx-fe-config';
import { AppConfig } from '../types/app-config.model';
import { MMRItem } from '../types/manage-my-repair-types';

@Injectable({
  providedIn: 'root',
})
export class ClaimsRedirectService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(CONFIG) private readonly config: AppConfig,
    private cookieService: CookieService
  ) {}

  redirect(
    { bundle, redirectUrl }: BundleResponse | any,
    timeSlot?: 'AM' | 'PM',
    mmrItem?: MMRItem
  ) {
    let debugValue: { [key: string]: string } | null = null;
    const isDebugMode = (this.config.debugMode ?? 'false') === 'true';

    console.log({ bundle });
    console.log(redirectUrl);
    if (isDebugMode && this.cookieService.check(this.config.debugCookieName)) {
      debugValue = this.cookieService
        .get(this.config.debugCookieName)
        .split('&')
        .reduce((previousValue, currentValue) => {
          const parts = currentValue.split('=');
          if (parts.length === 2) {
            return { ...previousValue, [parts[0]]: parts[1] };
          }
          return { ...previousValue };
        }, {});
    }

    let queryParams = `${this.config.claimRedirectQueryParams.replace(
      '[BUNDLE]',
      bundle
    )}`;

    if (mmrItem && mmrItem.manufacturer && mmrItem.code_description) {
      const sfxParams = new URLSearchParams({
        manufacturer: mmrItem.manufacturer,
        code_description: mmrItem.code_description,
      }).toString();
      const cookieExpiry = new Date();
      cookieExpiry.setHours(cookieExpiry.getHours() + 1);
      const cookieDomain = window.location.host.endsWith(
        'domesticandgeneral.com'
      )
        ? '.domesticandgeneral.com'
        : '.domgentest.cloud';
      this.cookieService.set(
        'sfx_routing',
        sfxParams,
        cookieExpiry,
        '/',
        cookieDomain
      );
    }

    if (timeSlot) {
      queryParams += '&timeSlot=' + timeSlot;
    }

    const redirectUrlToUse =
      redirectUrl ||
      (debugValue?.claimsAppHost
        ? `${debugValue.claimsAppHost}/?${queryParams}`
        : `${this.config.claimsAppHost}/?${queryParams}`);

    console.log(redirectUrlToUse);
    this.document.location.href = redirectUrlToUse;
  }
}
